import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Response } from '../shared/models/response.model';
import { Cartographie } from './models/cartographie.model';
import { CartographieUpdateRequest } from './request/update-request';

@Injectable({
  providedIn: 'root',
})
export class CartographieService {
  #http = inject(HttpClient);

  readonly BASE_URL = '/cartographies';

  findAll() {
    return this.#http.get<Response<Cartographie>>(this.BASE_URL);
  }

  findById(id: string) {
    return this.#http.get<Cartographie>(this.BASE_URL + '/' + id);
  }

  update(id: string, data: Partial<CartographieUpdateRequest>) {
    return this.#http.put<string>(this.BASE_URL + `/${id}`, data);
  }

  duplicate(idSource: string, nom: string) {
    return this.#http.post<Cartographie>(this.BASE_URL + `/duplication/${idSource}`, { nom });
  }
}
